import('../src/javascripts/attachments-redesign');
import("../src/javascripts/navigation");

$(document).ready(function () {
  const itemsPerPage = 6;
  const $container = $(".PortfolioList");
  const $prev = $(".Pagination__control--prev");
  const $next = $(".Pagination__control--next");
  const $items = $(".PortfolioList .RoundedWrapper");
  const $clear = $(".CheckboxFilter__clear");
  let filteredData = $items;
  let filters = {};
  let selectedFiltersMobile = {}; // for mobile
  let currentPage = 1;

  //clearing filters when opening a page using the back button
  clearFilters();

  filterByIndustryOnLoad();

  function displayResults() {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    if (filteredData.length) {
      $(".PortfolioList__no-result").hide();
      $(".Pagination").show();
    } else {
      $(".PortfolioList__no-result").show();
      $(".Pagination").hide();
    }

    $(".PortfolioList .RoundedWrapper").hide();
    filteredData.slice(startIndex, endIndex).show().css("display", "flex");

    displayPagination();
    disableArrows();
  }

  function displayPagination() {
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const typographyClassList = "Typography Typography--body3 Typography--bold Typography--alto";
    const itemClassList = "Pagination__item " + typographyClassList;
    const dotsClassList = "Pagination__item-dots " + typographyClassList;
    const displayRange = 1;

    $(".Pagination__item").parent().remove();
    $(".Pagination__item-dots").parent().remove();

    for (let i = 1; i <= totalPages; i++) {
      const pageLink = $(`<li><button class="${itemClassList} ${i === currentPage ? "active" : ""}">${i}</button></li>`);
      if (i === 1 || i === totalPages) {
        $(pageLink).insertBefore($next.parent());
      } else if (i >= currentPage - displayRange && i <= currentPage + displayRange) {
        $(pageLink).insertBefore($next.parent());
      } else if (i === currentPage - displayRange - 1 || i === currentPage + displayRange + 1) {
        $(`<li><div class='${dotsClassList}'>...</div></li>`).insertBefore($next.parent());
      }
    }

    $(".Pagination__item").click(function () {
      currentPage = parseInt($(this).text());
      displayResults();
      $("html, body").animate({ scrollTop: $container.offset().top - 100 }, 300);
    });
  }

  function disableArrows() {
    const $prev = $(".Pagination__control--prev");
    const $next = $(".Pagination__control--next");
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    currentPage === 1 ? $prev.attr("disabled", true) : $prev.attr("disabled", false);
    currentPage === totalPages ? $next.attr("disabled", true) : $next.attr("disabled", false);
  }

  function checkboxSelect(filterObj, filterType, $elem, $checkboxAll) {
    const width = $(window).width();
    const $clear = width > 768 ? $(".CheckboxFilter__clear") : $(".CheckboxFilter__clear--mobile");
    filterObj[filterType] === undefined && (filterObj[filterType] = []);

    $elem.is(":checked") ? filterObj[filterType].push($elem.val()) : filterObj[filterType].splice(filterObj[filterType].indexOf($elem.val()), 1);

    if (filterObj[filterType].length === 0) {
      $checkboxAll.prop("checked", true);
      $clear.hide();
    } else {
      $checkboxAll.prop("checked", false);
      $clear.show().css("display", "flex");
    }
  }

  function filterData() {
    const $items = $(".PortfolioList .RoundedWrapper");
    currentPage = 1;

    filteredData = $items.filter(function () {
      const project = $(this);
      let passesFilters = true;

      for (let filterName in filters) {
        if (filters.hasOwnProperty(filterName)) {
          const projectValues = project
            .find('[data-filter-param="' + filterName + '"]')
            .children()
            .text()
            .trim()
            .split(",");

          let match = false;
          for (let i = 0; i < projectValues.length; i++) {
            if (filters[filterName].indexOf(projectValues[i].trim()) !== -1 || filters[filterName].length === 0) {
              match = true;
              break;
            }
          }

          if (!match) {
            passesFilters = false;
            break;
          }
        }
      }

      return passesFilters;
    });

    displayResults();
    disableArrows();
  }

  function filterActiveButton($button) {
    const width = $(window).width();
    const $parent = $button.parent();
    const filtersList = width < 768 ? selectedFiltersMobile : filters;
    const filterType = $parent.data("filter");
    const $list = $parent.find(".CheckboxFilter__list");
    const selectedFilters = filtersList[filterType] && filtersList[filterType].length;

    width < 768 && $parent.toggleClass("active");
    $button.addClass("active");

    if (!selectedFilters && $list.is(":visible")) {
      width < 768 && $parent.removeClass("active");
      $button.removeClass("active");
    }
  }

  function clearFilters() {
    filters = {};
    selectedFiltersMobile = {};
    $(".CheckboxFilter__container").find("input[type='checkbox']").prop("checked", false);
    $(".CheckboxFilter__container").find("input[value='All']").prop("checked", true);
    filterData();
    $(".CheckboxFilter__clear").fadeOut(150);
    $(".CheckboxFilter__button").removeClass("active");
  }

  function checkboxHandler(isLoad = false) {
    const width = $(window).width();
    const $filter = $(this).closest(".CheckboxFilter__container");
    const checkboxAll = $filter.find("input[type='checkbox'][value='All']");
    const filterType = $filter.data("filter");

    if ($(this).val() === "All" && $(this).is(":checked")) {
      filters[filterType] = [];
      selectedFiltersMobile[filterType] = [];
      $filter.find("input[type='checkbox']").prop("checked", false);
      checkboxAll.prop("checked", true);
      width > 768 && filterData();
      return;
    }

    if (width < 768) {
      checkboxSelect(isLoad ? filters : selectedFiltersMobile, filterType, $(this), checkboxAll);
      isLoad && filterData();
    } else {
      checkboxSelect(filters, filterType, $(this), checkboxAll);
      filterData();
    }
  }

  function filterByIndustryOnLoad() {
    const industry = window.location.hash.replace("#", "").replace("-", " ");
    const $industryList = $(".CheckboxFilter__container[data-filter='industries']").find(".CheckboxFilter__list-content");
    const $button = $(".CheckboxFilter__container[data-filter='industries']").find(".CheckboxFilter__button--dropdown");

    $industryList.find("input[type='checkbox']").each(function () {
      if ($(this).val()?.toLowerCase() === industry) {
        $(this).prop("checked", true);
        checkboxHandler.bind($(this))(true);
        $button.addClass("active");
        $("html, body").animate({ scrollTop: $container.offset().top - 100 }, 300);
      }
    });
  }

  displayPagination();

  // filter checkbox handler
  $(".CheckboxFilter__list input[type='checkbox']").on("change", function () {
    checkboxHandler.bind($(this))();
  });

  // pagination arrow handlers
  $prev.on("click", function () {
    if (currentPage > 1) {
      currentPage--;
      displayResults();
      $("html, body").animate({ scrollTop: $container.offset().top - 100 }, 300);
    }
  });

  $next.on("click", function () {
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    if (currentPage < totalPages) {
      currentPage++;
      displayResults();
      $("html, body").animate({ scrollTop: $container.offset().top - 100 }, 300);
    }
  });

  // show/hide filter
  $(".CheckboxFilter__button--dropdown").on("click", function () {
    const $list = $(this).parent().find(".CheckboxFilter__list");
    const speed = 150;

    filterActiveButton($(this));
    !$list.is(":visible") ? $list.fadeIn(speed) : $list.fadeOut(speed);
  });

  // check selected filters on mobile on open
  $(".CheckboxFilter__button--popup").on("click", function () {
    selectedFiltersMobile = JSON.parse(JSON.stringify(filters));
    $(".CheckboxFilter__container").find("input[type='checkbox']").prop("checked", false);
    $(".CheckboxFilter__container").find("input[value='All']").prop("checked", true);
    $(".CheckboxFilter__list").removeAttr("style");

    for (let filterName in selectedFiltersMobile) {
      if (selectedFiltersMobile.hasOwnProperty(filterName)) {
        const filter = $(".CheckboxFilter__container[data-filter='" + filterName + "']");
        const $button = filter.find(".CheckboxFilter__button--dropdown");
        filter.find("input[type='checkbox']").prop("checked", false);
        filter.find("input[type='checkbox']").each(function () {
          if (selectedFiltersMobile[filterName].indexOf($(this).val()) !== -1) {
            $(this).prop("checked", true);
          }
        });
        selectedFiltersMobile[filterName].length && $button.addClass("active");
      }
    }

    $(".CheckboxFilter").fadeIn(150).css("display", "flex");
  });

  //close filter on mobile without applying changes
  $(".CheckboxFilter__header-close").on("click", function () {
    selectedFiltersMobile = {};
    $(".CheckboxFilter").fadeOut(150);
    $(".CheckboxFilter__container").removeClass("active");
    $(".CheckboxFilter__button").removeClass("active");
  });

  //filter on mobile
  $(".CheckboxFilter__button-filter").on("click", function () {
    filters = JSON.parse(JSON.stringify(selectedFiltersMobile));
    selectedFiltersMobile = {};
    filterData();
    $(".CheckboxFilter__container").removeClass("active");
    $(".CheckboxFilter__button").removeClass("active");
    $(".CheckboxFilter").fadeOut(150);
  });

  // clear filters
  $clear.on("click", () => clearFilters());

  // clean styles on resize
  $(window).on("resize", function () {
    const width = $(window).width();
    if (width > 768) {
      $(".CheckboxFilter__list").removeAttr("style");
      $(".CheckboxFilter").removeAttr("style");
      $(".CheckboxFilter__container").removeClass("active");
    }
  });

  //close checkbox filter on click outside
  $(document).mouseup(function (e) {
    const width = $(window).width();
    if (width < 768) {
      return;
    }

    const $list = $(".CheckboxFilter__list");
    const $button = $(".CheckboxFilter__button--dropdown");

    if (!$list.is(e.target) && $list.has(e.target).length === 0) {
      $button.each(function () {
        const $list = $(this).parent().find(".CheckboxFilter__list");
        $list.is(":visible") && filterActiveButton($(this)); // remove button active class
      });
      $list.fadeOut(150);
    }
  });

  $(".Header-link.Header-link--subMenuTitle").on("click", function () {
    const hrevVal = $(this).attr("href");

    if (hrevVal.includes("/projects#")) {
      clearFilters();
      setTimeout(() => {
        filterByIndustryOnLoad();
      }, 200);
    }
  });
});
